import angular from 'angular';
import { snakeCase } from 'lodash';

module.exports = angular.module('common.filters.status-date', [])
  .filter('statusDate', function() {
    return function(listing) {
      if (listing) {
        switch (snakeCase(listing.listing_status)) {
          case 'active':
            return listing.list_date;
          case 'pending':
            return listing.pending_date;
          case 'closed':
            return listing.close_date;
          case 'cancelled':
            return listing.cancel_date;
          case 'expired':
            return listing.expiration_date;
          case 'temp_off_market':
            return listing.temp_off_market_date;
        }
      }
      return null;
    };
  })
  .name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/status-date.js
 **/